export function resolvePublicLogoUrl(value, version) {
  const raw = String(value || "").trim();
  const cacheSuffix = version ? `?v=${version}` : "";

  if (!raw) {
    return `/assets/logo.avif${cacheSuffix}`;
  }

  if (/^https?:\/\//i.test(raw)) {
    if (!version) return raw;
    return `${raw}${raw.includes("?") ? "&" : "?"}v=${version}`;
  }

  const normalized = raw.startsWith("/") ? raw : `/${raw}`;
  return `${normalized}${cacheSuffix}`;
}
